export default "<div class=\"content-wrapper\">\n  <div class=\"card no-radius\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"